import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RootState } from '../../../../../../../@types/RootState';
import { Layout } from '../../../../../../../components';
import { selectorRulesDataTotalElements } from '../../../../../../../reducers/ipa/strategy/rulesPage/table/totalElements';

type RulesPageTableHeadingProps = RouteComponentProps & ReturnType<typeof mapToStateToProps>;

const RulesPageTableHeading = ({ totalElements }: RulesPageTableHeadingProps) => {
  return (
    <Layout.Section padded>
      Foram encontrados
      <strong> {totalElements} regras </strong>
      no total
    </Layout.Section>
  );
};

const mapToStateToProps = (state: RootState) => ({
  totalElements: selectorRulesDataTotalElements(state),
});

export default withRouter(connect(mapToStateToProps)(RulesPageTableHeading));
